import i18n from '~/locales/i18n';

i18n.addResourceBundle('ar', 'app', {
  packagesAndPrices: 'الباقات والأسعار',
  selectPlanDescription: 'اختر الباقة التي تناسب احتياجاتك بشكل أفضل',
  individuals: 'الأفراد',
  companies: 'الشركات',
  faqsTitle: 'الاسئلة الشائعة',
  availableAreas: 'المناطق المتاحة للإعلان',
  tiersTitle: 'المناطق  ',
  tiersDescription: 'تغطي هذه الباقة المناطق والأحياء التالية لإضافة الإعلانات',
  areas: 'مناطق',
  noAreasFound: 'لا توجد مناطق متاحة.',
  month: 'شهر',
  months: 'شهور',
  subscribeNow: 'اشترك الآن',
  pointsValue: '{{value}} نقطة',
  pointsIncludedValue: 'تتضمن <tag>{{value}}</tag> نقطة',
  toAddListings: 'لإضافة إعلانات',
  payAsYouGoTitle: 'ادفع حسب احتياجك',
  payAsYouGoDescription: 'ادفع فقط سعر الإعلان دون الحاجة للاشتراك في باقة.',
  customizePackageTitle: 'باقة مُخصصة',
  customizePackageDescription: 'تناسب احتياجات شركتك',
  contactUs: 'تواصل معنا',
  addonsPackagesTitle: 'الباقات الاضافية',
  addonsPackageDescription:
    'استمتع بمزايا إضافية لتحقيق أقصى استفادة من اشتراكك',
  addToMyPackage: 'اضف الي باقتي',
  egpPerMonth: 'ج.م/شهر',
  noIndividualPackagesFound: 'لا توجد باقات فردية متاحة.',
  noCompaniesPackagesFound: 'لا توجد باقات للشركات متاحة.',
  customizePackageFooter: 'الرد خلال يوم عمل واحد من ادخال البيانات',
  rentOnly: 'لإيجار فقط',
  pointsTooltip: 'يمكن استخدام النقاط لنشر عقارات جديدة أو تمييز إعلاناتك.',
  activationFees: 'رسوم التفعيل <tag>(اول مرة فقط)</tag>',
  packageSubscriptionExpiry: 'تنتهي صلاحية الاشتراك بعد {{days}} يوم',
  packageCreditExpiry: 'تنتهي صلاحية النقاط بعد {{days}} يوم',
  allAreas: 'الجميع',
  moreServices: 'مزايا اخري',
  lessServices: 'مزايا اقل ',
  packagePaymentInfo: 'بيانات الدفع',
  packagePaymentSummary: 'ملخص الدفع',
});
